import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import archives from './routerModule/archives.js'
import base from './routerModule/base.js'
import debug from './routerModule/debug.js'
import login from './routerModule/login.js'
import order from './routerModule/order.js'
import power from './routerModule/power.js'
import systemConfig from './routerModule/systemConfig.js'
import unitKanBan from './routerModule/unitKanBan.js' //单位概况
import projectCustomMade from './routerModule/projectCustomMade.js' //项目定制功能(如天澄、天津石化)
import abbNewHtml from './routerModule/abbNewHtml.js' //新增ABB页面

//各个系统
import zhiHuiAnQuanYongDian from './routerModule/system/zhiHuiAnQuanYongDian.js' //智慧安全用电
import EnergyEfficiencySystem from './routerModule/system/EnergyEfficiencySystem.js' //能耗监管平台
import meterReading from './routerModule/system/meterReading.js' //抄表系统
import prepaid from './routerModule/system/prepaid.js' //预付费界面
import waterMeter from './routerModule/waterMeter.js' //中山大学水表系统
//按项目定制页面
export default new Router({
	routes: [
		...archives,
		...base,
		...debug,
		...login,
		...meterReading,
		...order,
		...power,
		...systemConfig,
		...EnergyEfficiencySystem,
		...zhiHuiAnQuanYongDian,
		...prepaid,
		...unitKanBan,
		...projectCustomMade,
		...abbNewHtml,
		...waterMeter
	]
})